import { render, staticRenderFns } from "./PosManagerReportElement.vue?vue&type=template&id=35c273f3&"
import script from "./PosManagerReportElement.vue?vue&type=script&lang=ts&"
export * from "./PosManagerReportElement.vue?vue&type=script&lang=ts&"
import style0 from "./PosManagerReportElement.vue?vue&type=style&index=0&id=35c273f3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports